import { Decoder, field, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../../Resource/Decoders';
import { experienceResourcesDecoder } from '../../../Decoders';
import {
  ProductCollectionLicenseUpdatedPayload,
  ProductCollectionLicenseUpdatedResource,
} from './Types';

const productCollectionLicenseUpdatedPayloadDecoder: Decoder<ProductCollectionLicenseUpdatedPayload> =
  succeed({}).assign('allExperiences', field('all_experiences', experienceResourcesDecoder));

export const productCollectionLicenseUpdatedResourceDecoder: Decoder<ProductCollectionLicenseUpdatedResource> =
  resourceDecoder(productCollectionLicenseUpdatedPayloadDecoder);
